import SidebarItem from "./SidebarItem";
import { useSectionContext } from "../../hooks/useSectionContext";
import { useUserContext } from "../../hooks/useUserContext";
import { sidebarItems } from "../../constants";

export default function ProfileSidebar() {
  const { activeSection, scrollToSection } = useSectionContext();
  const { hasExpiredPaymentMethods, hasUnsignedDocuments } = useUserContext();

  return (
    <div className="max-sm:tw-hidden tw-w-52 tw-py-4 tw-px-3 tw-flex tw-flex-col tw-gap-2">
      {sidebarItems().map((item) => (
        <SidebarItem
          key={item.id}
          title={item.title}
          isActive={activeSection === item.id}
          hasAlert={
            (item.id === "billing" && hasExpiredPaymentMethods) ||
            (item.id === "documents" && hasUnsignedDocuments)
          }
          onClick={() => scrollToSection(item.id, "smooth")}
          sectionId={item.id}
        />
      ))}
    </div>
  );
}
